import "axios";
import "../store";
import config from "../config";
import "./auth-header";
import unroutedEndpoint from "./unroutedEndpoint";
import "moment";

void (config.API_URL);

const view = () => {
  // Flask serves consultation form previews only on the public /api/v1/widget/formpreview family; the authenticated route was never implemented.
  return unroutedEndpoint(
    "afterlogin/formpreview/view",
    "widget/formpreview"
  );
};

const consultatioformlinkApiController = {
  view,
};

export default consultatioformlinkApiController;
